/* istanbul ignore file */
import { inject, Injectable } from '@angular/core';
import { OidcSecurityService, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { TT_AUTH_CONFIGS } from '../../auth.provider';
import { LoggerService } from './logger.service';

/**
 * This is an exact copy of the loggerService of the angular-auth-oidc-client packaage which should
 * be made public but wasn't.
 * https://github.com/damienbod/angular-auth-oidc-client/blob/main/projects/angular-auth-oidc-client/src/lib/logging/logger.service.ts
 */
@Injectable({ providedIn: 'root' })
export class LoggerWithConfigurationService {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  private readonly loggerService = inject(LoggerService);

  private configuration: OpenIdConfiguration = inject(TT_AUTH_CONFIGS)[0];

  public logError(
    message: string | object,
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args: any[]
  ): void {
    this.loggerService.logError(this.configuration, message, ...args);
  }

  public logWarning(
    message: string | object,
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args: any[]
  ): void {
    this.loggerService.logWarning(this.configuration, message, ...args);
  }

  public logDebug(
    message: string | object,
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args: any[]
  ): void {
    this.loggerService.logDebug(this.configuration, message, ...args);
  }
}
